import { render, staticRenderFns } from "./AddTagPage.vue?vue&type=template&id=4f4f4bb8&"
import script from "./AddTagPage.vue?vue&type=script&lang=js&"
export * from "./AddTagPage.vue?vue&type=script&lang=js&"
import style0 from "./AddTagPage.vue?vue&type=style&index=0&id=4f4f4bb8&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports